import styled from 'styled-components';

export const StyledInput = styled.input`
    font-weight: bold;
    color: #83c9f5;
`;

